import axios from "axios";
import { react, useContext, useEffect, useState } from "react";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { errorAlert } from "../../Components/Alerts";
import { StatementsRowComponent } from "../../Components/StatementsRowComponent";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import TaxpayerInfo from "../../Components/TaxpayerInfo";
import FinancialStatementRow from "../../Components/FinancialStatementRow";

export default function NdryshimiEkuitetit() {
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);
    const [companyName, setCompanyName] = useState("");
    const [idNumber, setIdNumber] = useState("");
    const [address, setAdress] = useState("");
    const [phone, setPhone] = useState("");

    const fetchCompaniesData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Companies/getCompanyDetails', { headers });
            setCompanyName(response.data[0].CompanyName);
            setIdNumber(response.data[0].IdentificationNumber);
            setAdress(response.data[0].Address);
            setPhone(response.data[0].PhoneNumbers);

        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const firstHeader = [
        { id: 1, label: "Gjendja më 1 janar 2025", values: [152545210, 20, 30, 40] },
    ];

    const firstBody = [
        { id: 2, label: "Fitimi/(humbja) i/e vitit", values: [10, 20, 30, 40] },
        { id: 3, label: "Diferencat nga përkthimet valutore", values: [5, 15, 25, 35] },
        { id: 4, label: "Dividendat/Tërheqjet", values: [8, 18, 28, 38] },
        { id: 5, label: "Deponimet e kapitalit shtesë", values: [8, 18, 28, 38] },
        { id: 6, label: "Ndarja e rezervave", values: [8, 18, 28, 38] }
    ];

    const secondHeader = [
        { id: 7, label: "Gjendja më 31 dhjetor 2023", values: [10, 20, 30, 40], color: "yellow" },
    ];

    const secondBody = [
        { id: 8, label: "Fitimi/(humbja) i/e vitit", values: [10, 20, 30, 40] },
        { id: 9, label: "Diferencat nga përkthimet valutore", values: [5, 15, 25, 35] },
        { id: 10, label: "Dividendat/Tërheqjet", values: [8, 18, 28, 38] },
        { id: 11, label: "Deponimet e kapitalit shtesë", values: [8, 18, 28, 38] },
        { id: 12, label: "Ndarja e rezervave", values: [8, 18, 28, 38] }
    ];
    const footer = [
        { id: 13, label: "Gjendja më 31 dhjetor 2024", values: [10, 20, 30, 40], color: "yellow" }
    ];

    const taxpayerData = {
        period: "2025",
        uniref: "Uniref",
        fiscalNumber: "123456",
        name: "Vellezërit Telaku",
        address: "Haki Telaku, banje",
        contactPerson: "Vellezërit Telaku",
        activityCode: "0000",
        phone: "+383 49 418 742"
    };

    useEffect(() => {
        fetchCompaniesData();
    }, []);

    return (
        <div style={{ paddingTop: "50px" }}>
            <h1>Ne Zhvillim</h1>
            {/* <div className='VatDeclaration__Container'>
                <div>
                    <h5><b>Pasqyra e ndryshimeve në ekuitet/kapital për vitin që përfundon më 31 dhjetor</b></h5>
                </div>
                <div className="app">
                    <TaxpayerInfo data={taxpayerData} />
                </div>
                <hr></hr>
                <StatementsRowComponent data={firstHeader} />
                <StatementsRowComponent data={firstBody} />
                <StatementsRowComponent data={secondHeader} />
                <StatementsRowComponent data={secondBody} />
                <StatementsRowComponent data={footer} />
            </div> */}
        </div>
    )
}